import { useMemo } from 'react';

import { useFertilizationContext } from './useFertilizationContext';

import './Fertilization.css';

type Props = {
  className?: string;
};
export const FertilizationCalculations = ({ className }: Props) => {
  const { pulledSemenData, fertilizationDonorScheduleData } =
    useFertilizationContext();
  const donorRowCount = fertilizationDonorScheduleData?.length;
  const semenRowCount = pulledSemenData?.length;
  const numPlates = useMemo(() => {
    return donorRowCount ? Math.ceil((donorRowCount ?? 0) / 2 + 2) : 0;
  }, [donorRowCount]);
  const plateMedia = useMemo(() => {
    return Math.ceil(numPlates * 1.5);
  }, [numPlates]);
  const numBulls = useMemo(() => {
    return (semenRowCount ?? 0) * 4;
  }, [semenRowCount]);

  return (
    <div className={`fertilization__calculations ${className}`.trim()}>
      <h4 className="calculations__plate-calculation">
        Plate Calculation: {numPlates}
      </h4>
      <h4 className="calculations__plate-media">Plate Media: {plateMedia}</h4>
      <h4 className="calculations__wash-media">Wash Media: {numBulls}</h4>
    </div>
  );
};
